import {DetailsTabContentWrapper} from '@/features/projects/components/details-tab-content-wrapper/DetailsTabContentWrapper'
import {useTranslation} from '@/translations/i18n'
import {useOutletContext} from 'react-router-dom'
import {ProjectExtended} from '@/features/projects/types'
import {Helmet} from 'react-helmet'
import {ActivityLogsList} from '@/features/entity-activity-logs/components/activity-logs-list/ActivityLogsList'

export const ProjectDetailsLogs = () => {
    const {t} = useTranslation()
    const {project} = useOutletContext<{project: ProjectExtended}>()

    return (
        <DetailsTabContentWrapper>
            <Helmet title={t('commons:fullname_details_meta_title', {fullName: project.patient.fullName})} />
            <ActivityLogsList
                entityType="projects"
                entityId={project.id}
                projectLifecycle={{projectRefType: project.projectRefType, projectType: project.type}}
            />
        </DetailsTabContentWrapper>
    )
}
